import type {SlotGameStore, BaseComponentConfig, ReelsetComponent, Spine} from "@gamzix/slot_core";

class BigWinComponent extends Game.src.component.BaseComponent {
    protected waitClick: () => Promise<void>;

    protected animationState; //какая сейчас анимация проигрывается
    protected array = []; //массив множителей, которые должны проиграться в анимации

    protected countBet: number = 0;
    protected winAmount: any = 0;
    protected winAmountFinal: any = 0; //потом заменить на this.store.gameData.winAmount
    protected tweenCounterTime: number = 4000; //общее время анимации каунтера(меняется динамечески под каждый вин)
    protected alphaTimeDelay: number = 300;
    protected percentWinAmount: number = 0;

    protected isWinAllLabel: boolean = false;
    protected counterToogle: boolean = false;
    protected lastStage: boolean = false;
    protected isShownOnSpin: boolean = false;
    protected tween; // анимация каунтера
    protected container;
    protected text;
    protected popup;
    protected lastState;

    public obj = {
        BIG_WIN: {
            event: "BigWinComponent.START_BIG_WIN",
            multiplier: 10,
            multForCounter: 110, //множитель для скорости каунтера
            percentSlow: 25, //какой процент от винспин начнет замедляться
            start_idle: false,
            skin: "bigwin",
            animations: {
                START: "big_win_start",
                IDLE: "big_win_idle",
                END: "big_win_end"
            }
        },
        MEGA_WIN: {
            event: "BigWinComponent.START_MEGA_WIN",
            multiplier: 25,
            multForCounter: 40,
            percentSlow: 20,
            toogle: true,
            start_idle: false,
            skin: "megawin",
            animations: {
                START: "mega_win_start",
                IDLE: "mega_win_idle",
                END: "mega_win_end"
            }
        },
        EPIC_WIN: {
            event: "BigWinComponent.START_EPIC_WIN",
            multiplier: 50,
            multForCounter: 30,
            percentSlow: 5,
            toogle: true,
            skin: "epicwin",
            start_idle: false,
            animations: {
                START: "epic_win_start",
                IDLE: "epic_win_idle",
                END: "epic_win_end"
            }
        }
    }

    static events = {
        COUNTER_START: "BigWinComponent.COUNTER_START",
        COUNTER_STOP: "BigWinComponent.COUNTER_STOP",
        COUNTER_SLOW: "BigWinComponent.COUNTER_SLOW",
        // END_POPUP: "BigWinComponent.END_POPUP",
        CLOSED: "BigWinComponent.CLOSED"
    }

    constructor(config: BaseComponentConfig) {
        super(config);

        this.status_checkers = {
            ...super.getStatusCheckers(),

            isWinAllLabel: () => this.isWinAllLabel,
        };
    }

    onGameReady() {
        game.once('SET_WAIT_CLICK', ({waitClick}) => this.waitClick = waitClick);

        super.onGameReady();

        this.container = game.tree.findByName("bigwin.bigwin_container");
        this.text = game.tree.findByName("bigwin.bigwin_label");
    }

    async showStartPopup() {
        this.winAmount = 0;
        this.isWinAllLabel = true;
        this.obj.MEGA_WIN.toogle = true;
        this.obj.EPIC_WIN.toogle = true;

        this.popup = <Spine>game.builder.create(this.options.config.bigWinSpineConfig);
        this.view.addChild(this.popup);

        this.playAlphaContainer();

        this.text.options.text = this.store.toFormatMoney(1);
        this.text.updateViewOptions();

        this.startStateAnimation(this.obj.BIG_WIN, this.obj.BIG_WIN.event)

        if (this.store.gameSettings.isFastSpin) {
            return this.lastStagePlay();
        } else {
            this.startTweenAnimationText();
        }

        await Promise.race([
            game.oncePromise(BigWinComponent.events.CLOSED)
        ])
    }

    async addArrayMultiplier() { //добавить все возможные множители в массив и просчитать время анимации каунтера
        if (this.winAmountFinal >= this.store.gameData.bet * this.obj.BIG_WIN.multiplier) {
            this.arrayMultiplier(this.obj.BIG_WIN);
        }
        if (this.winAmountFinal >= this.store.gameData.bet * this.obj.MEGA_WIN.multiplier) {
            this.arrayMultiplier(this.obj.MEGA_WIN);
        }
        if (this.winAmountFinal >= this.store.gameData.bet * this.obj.EPIC_WIN.multiplier) {
            this.arrayMultiplier(this.obj.EPIC_WIN);
        }
        return this.array;
    }

    arrayMultiplier(obj) {
        this.array.push(obj);
        this.percentWinAmount = this.winAmountFinal / 100 * obj.percentSlow;
        this.tweenCounterTime = this.countBet * obj.multForCounter;
    }

     async checkWinAmount() { //вызов попапов при достижении суммы в каунтере
        if (this.obj.MEGA_WIN.toogle && this.obj.BIG_WIN.start_idle && (this.winAmount >= this.store.gameData.bet * this.obj.MEGA_WIN.multiplier)) {
            this.obj.MEGA_WIN.toogle = false;

            if(this.animationState !== this.array[this.array.length - 1]) {
                // game.emit(BigWinComponent.events.END_POPUP);

                await this.popup.playAnimation(this.obj.BIG_WIN.animations.END, false);
            }
            this.startStateAnimation(this.obj.MEGA_WIN, this.obj.MEGA_WIN.event)
        }

        else if (this.obj.EPIC_WIN.toogle && this.obj.MEGA_WIN.start_idle && (this.winAmount >= this.store.gameData.bet * this.obj.EPIC_WIN.multiplier)) {
            this.obj.EPIC_WIN.toogle = false;

            if(this.animationState !== this.array[this.array.length - 1]) {
                // game.emit(BigWinComponent.events.END_POPUP);

                await this.popup.playAnimation(this.obj.MEGA_WIN.animations.END, false);
            }
            this.startStateAnimation(this.obj.EPIC_WIN, this.obj.EPIC_WIN.event)
        }

        if(!this.counterToogle && this.text.options.text === this.store.toFormatMoney(this.winAmountFinal)){
            this.counterToogle = true;
            game.emit(BigWinComponent.events.COUNTER_STOP);
        }
    }

    //старт стейта и показ анимации
    async startStateAnimation(obj, event){
        this.animationState = obj;
        this.popup.setSkin(obj.skin);

        game.emit(event);

        await this.popup.playAnimation(obj.animations.START, false);
        obj.start_idle = true;
        this.popup.playAnimation(obj.animations.IDLE, true);
    }

    async playAlphaContainer() {
        await game.utils.GameUtils.playAlphaAnimation(this.text, {from: 0, to: 1, time: this.alphaTimeDelay, timeWait: 0});
        await game.utils.GameUtils.playAlphaAnimation(this.container, {from: 0, to: 1, time: this.alphaTimeDelay, timeWait: 0});
    }

    async startTweenAnimationText() {
        await game.utils.delay(this.alphaTimeDelay);

        this.startCounter(this.winAmountFinal - this.percentWinAmount, 0, createjs.Ease.linear, this.tweenCounterTime, 'START')
            .then(() => this.startCounter(this.winAmountFinal, this.winAmount, createjs.Ease.getPowOut(2), 2500, 'SLOW').then(() => this.lastStagePlay()))

        await Promise.race([
            this.waitClick().then(() => this.lastStagePlay()),
            game.onceDataPromise('Button.clicked', {
                component: 'bigWin',
                name: 'bigWin.click_button'
            }).then(() => this.lastStagePlay()),
            game.oncePromise(BigWinComponent.events.CLOSED)
        ])
    }

    async startCounter(winAmount, textNumber, tween, time, emit): Promise<any> {
        game.emit(`BigWinComponent.COUNTER_${emit}`);

        return new Promise((resolve) => {
            const _tw = {text: textNumber};

            this.tween = createjs.Tween.get(_tw, {
                onChange: () => {
                    this.winAmount = _tw.text;
                    this.checkWinAmount();
                    this.text.options.text = this.store.toFormatMoney(_tw.text);
                    this.text.updateViewOptions();
                },
            }).to({text: winAmount}, time, tween).call(resolve);
        })
    }

    get reelset(): ReelsetComponent {
        return <any>game.component.reelset;
    }

    async lastStagePlay() {
        if (this.lastStage) return;
        this.lastStage = true;

        if(!this.counterToogle) game.emit(BigWinComponent.events.COUNTER_STOP);

        this.lastState = this.array[this.array.length - 1];
        this.removeTweenTextCounter();

        if (this.animationState !== this.lastState) {
            if (this.animationState.start_idle) await this.popup.playAnimation(this.animationState.animations.END, false);

            this.popup.setSkin(this.lastState.skin);

            game.emit(this.lastState.event);

            await this.popup.playAnimation(this.lastState.animations.START, false);

            // game.emit(BigWinComponent.events.END_POPUP);

            await this.popup.playAnimation(this.lastState.animations.END, false);

            game.emit(BigWinComponent.events.CLOSED);
        } else {
            // if(!this.lastState.start_idle) await this.popup.playAnimation(this.lastState.animations.START, false);

            // game.emit(BigWinComponent.events.END_POPUP);

            await this.popup.playAnimation(this.lastState.animations.END, false);

            game.emit(BigWinComponent.events.CLOSED);
        }
    }

    removeTweenTextCounter() {
        game.utils.removeCall(this.tween);

        this.text.options.text = this.store.toFormatMoney(this.winAmountFinal);
        this.text.updateViewOptions();
    }

    async hideBigwinPopup() {
        await game.utils.GameUtils.playAlphaAnimation(this.container, {from: 1, to: 0, time: 300, timeWait: 0});

        this.text.options.text = " ";
        game.utils.PIXIUtils.remove(this.popup);

        this.array = [];
        this.countBet = 0;
        this.counterToogle = false;
        this.obj.EPIC_WIN.start_idle = false;
        this.obj.MEGA_WIN.start_idle = false;
        this.obj.BIG_WIN.start_idle = false;
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }

    betCount() {
        let number = this.winAmountFinal;
        do {
            number -= this.store.gameData.bet;
            if (number < 0) return;
            this.countBet++;
        } while (number > 0);
    }

    getFSMHandlers() {
        return {
            IDLE: {
                enter: {
                    on: async () => {
                        this.isShownOnSpin = false;
                    }
                }
            },
            SHOW_WIN: {
                enter: {
                    on: async () => {
                        this.lastStage = false;
                        if (this.isShownOnSpin) return;

                        this.winAmountFinal = this.store.gameData.spinWinAmount;

                        this.betCount();

                        let check = await this.addArrayMultiplier();
                        if (check.length === 0) return false;

                        this.isShownOnSpin = true;

                        this.reelset.playAllWinsLoopAnimation();

                        await this.showStartPopup();
                        this.hideBigwinPopup();

                        return this.reelset.playAllIdleAnimation();
                    }
                }
            }
        }
    }
}

//@ts-ignore
Game.src.component.BigWinComponent = BigWinComponent;
